class EnhancedAccordionItem extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {}
}

customElements.define('enhanced-accordion-item', EnhancedAccordionItem, {extends: 'section'});